<template>
  <svg
    :width="width"
    height="30"
    viewBox="0 0 34 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.7006 30H0V17.6838C0 13.1495 0.926398 9.57108 2.77919 6.94853C4.63199 4.32598 7.80821 2.0098 12.3079 0L15.7006 6.54412C12.9335 7.86765 11.0205 9.19118 9.96178 10.5147C8.90304 11.8137 8.31352 13.3578 8.19321 15.1471H15.7006V30ZM34 30H18.2994V17.6838C18.2994 13.1495 19.2258 9.57108 21.0786 6.94853C22.9314 4.32598 26.1076 2.0098 30.6072 0L34 6.54412C31.2328 7.86765 29.3199 9.19118 28.2611 10.5147C27.2024 11.8137 26.6129 13.3578 26.4926 15.1471H34V30Z"
      :fill="iconColor"
    />
  </svg>
</template>

<script lang="ts">
import Vue, { PropType } from "vue"
export default Vue.extend({
  name: "QuoteIcon",
  props: {
    color: String,
    width: { type: Number, default: 31 },
  },
  computed: {
    iconColor: function () {
      let color = this.color
        ? this.color
        : this.$vuetify.theme.themes.light.textColor
      return color
    },
  },
})
</script>
